import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formatiert einen Zeitstempel in Schweizer Zeit (Europe/Zurich).
 * Das Backend speichert `created_at` teils als NAIVES UTC (ISO-String ohne
 * Zeitzone). `new Date(...)` würde solche Strings als Lokalzeit interpretieren
 * → Anzeige z.B. 21:0X statt 23:0X. Daher: offsetlose ISO-Strings als UTC
 * behandeln ('Z' anhängen) und dann in Schweizer Zeit ausgeben.
 */
export function formatSwiss(value, opts = {}) {
  if (!value) return '';
  let s = value;
  if (typeof s === 'string') {
    const hasTz = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s.trim());
    if (!hasTz && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s.trim())) s = s.trim() + 'Z';
  }
  const d = new Date(s);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString('de-CH', { timeZone: 'Europe/Zurich', ...opts });
}
